// Admin-bucket org-wide unsent rollup — §5.3 stub until cross-user API lands.
//
// Read-only / RA-3: no send CTA, no peek driver in registry. R3: null when
// count is unknown or zero.

import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";
import { formatOrgUnsentRollupBodyLine } from "./adminDockCopy";

export type ActivityDockOrgUnsentRollupSectionProps = {
  orgUnsentRollupCount: number | null;
  currentMode?: PrimaryMode | null;
  onOpenDashboard?: () => void;
};

export function ActivityDockOrgUnsentRollupSection({
  orgUnsentRollupCount,
  currentMode = null,
  onOpenDashboard,
}: ActivityDockOrgUnsentRollupSectionProps) {
  if (orgUnsentRollupCount == null || orgUnsentRollupCount <= 0) return null;

  const bodyLine = formatOrgUnsentRollupBodyLine(orgUnsentRollupCount, currentMode);

  return (
    <section
      aria-label="Org-wide unsent leads snapshot"
      className="mt-3 rounded-2xl border border-gray-300 bg-gray-50 px-3 py-3 text-left text-xs text-gray-800 dark:border-gray-600 dark:bg-zinc-900/40 dark:text-gray-200"
    >
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0">
          <div className="text-[11px] font-semibold uppercase tracking-wide opacity-80">
            Team unsent leads
          </div>
          <p className="mt-1 text-[12px] leading-snug">{bodyLine}</p>
        </div>
        {onOpenDashboard ? (
          <button
            type="button"
            onClick={onOpenDashboard}
            className="shrink-0 rounded-lg border border-gray-400 bg-white px-2.5 py-1.5 text-[11px] font-semibold text-gray-800 hover:bg-gray-100 dark:border-gray-500 dark:bg-zinc-800 dark:text-gray-100 dark:hover:bg-zinc-700"
          >
            Dashboard
          </button>
        ) : null}
      </div>
    </section>
  );
}
